import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElementModel } from '@app/clinical-feedback/clinical-feedback.model';
import { NewClinicalFeedbackFormHelper } from '@app/clinical-feedback/new-clinical-feedback/new-clinical-feedback.helper';

@Component({
    selector: 'app-yes-no',
    templateUrl: './yes-no.component.html',
    styleUrls: ['./yes-no.component.scss']
})
export class YesNoComponent {
    @Input() formElementModel!: FormElementModel;
    @Input() parentFormGroup!: UntypedFormGroup;

    get control() {
        if (!this.formElementModel.id) {
            throw new Error(`formElementId not set for '${this.formElementModel.label}'.`);
        }

        return this.parentFormGroup.get(this.formElementModel.id);
    }

    get asterisk() {
        return NewClinicalFeedbackFormHelper.getAsteriskIfRequired(this.control);
    }
}
